(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wallet-charger-preview"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => {
    document.querySelectorAll('[data-wallet-charger]').forEach(section => {
      if (section.dataset.chargerReady) return;
      section.dataset.chargerReady = 'true';
      const panels = Array.from(section.querySelectorAll('[data-charger-panel]'));
      const buttons = Array.from(section.querySelectorAll('[data-charger-target]'));
      buttons.forEach(button => button.addEventListener('click', () => {
        const selected = panels.find(panel => panel.id === button.dataset.chargerTarget);
        if (!selected) return;
        panels.forEach(panel => { panel.hidden = panel !== selected; });
        buttons.forEach(control => control.setAttribute('aria-pressed', String(control === button)));
      }));
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wallet-journey"] && !Shopify.designMode) return;
  try {
    
const walletVideoStates = new Map();
const walletMotionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');

function syncWalletVideo(state) {
  const { video, source } = state;
  const canAnimate = !walletMotionPreference.matches && !document.hidden;

  if (walletMotionPreference.matches && state.loaded) {
    video.pause();
    source.removeAttribute('src');
    video.load();
    state.loaded = false;
    return;
  }

  if (canAnimate && state.near && !state.loaded) {
    source.src = window.matchMedia('(max-width: 749px)').matches
      ? source.dataset.srcMobile
      : source.dataset.srcDesktop;
    state.loaded = true;
    video.load();
  }

  if (!canAnimate || !state.visible || !state.loaded) {
    video.pause();
    return;
  }

  if (video.paused) {
    const playback = video.play();
    if (playback && typeof playback.then === 'function') {
      playback.then(() => {
        if (!walletVideoStates.has(video) || walletMotionPreference.matches || document.hidden || !state.visible) video.pause();
      }).catch(() => {});
    }
  }
}

function initWalletVideos(scope = document) {
  scope.querySelectorAll('[data-wallet-video]').forEach(video => {
    if (walletVideoStates.has(video)) return;

    const source = video.querySelector('source');
    if (!source) return;

    video.autoplay = false;
    video.muted = true;
    const state = { video, source, near: false, visible: false, loaded: false };
    walletVideoStates.set(video, state);

    if ('IntersectionObserver' in window) {
      state.loadObserver = new IntersectionObserver(entries => {
        state.near = entries[0].isIntersecting;
        syncWalletVideo(state);
      }, { rootMargin: '300px 0px' });
      state.playObserver = new IntersectionObserver(entries => {
        state.visible = entries[0].isIntersecting;
        if (state.visible) state.near = true;
        syncWalletVideo(state);
      });
      state.loadObserver.observe(video);
      state.playObserver.observe(video);
    } else {
      const updatePosition = () => {
        const bounds = video.getBoundingClientRect();
        state.near = bounds.bottom > -300 && bounds.top < window.innerHeight + 300;
        state.visible = bounds.bottom > 0 && bounds.top < window.innerHeight;
        syncWalletVideo(state);
      };
      state.updatePosition = updatePosition;
      window.addEventListener('scroll', updatePosition, { passive: true });
      window.addEventListener('resize', updatePosition);
      updatePosition();
    }
  });
}

function syncWalletVideos() {
  walletVideoStates.forEach(syncWalletVideo);
}

document.addEventListener('visibilitychange', syncWalletVideos);
if (walletMotionPreference.addEventListener) {
  walletMotionPreference.addEventListener('change', syncWalletVideos);
} else {
  walletMotionPreference.addListener(syncWalletVideos);
}

function initWalletComparisons(scope = document) {
  scope.querySelectorAll('[data-wallet-compare]').forEach(root => {
    if (root.dataset.initialized) return;

    root.dataset.initialized = 'true';

    const input = root.querySelector('input');

    input.addEventListener('input', () => {
      root.style.setProperty('--position', input.value + '%');
    });
  });
}

initWalletComparisons();
initWalletVideos();

document.addEventListener('shopify:section:load', event => {
  initWalletComparisons(event.target);
  initWalletVideos(event.target);
});

document.addEventListener('shopify:section:unload', event => {
  walletVideoStates.forEach((state, video) => {
    if (!event.target.contains(video)) return;
    video.pause();
    state.loadObserver?.disconnect();
    state.playObserver?.disconnect();
    if (state.updatePosition) {
      window.removeEventListener('scroll', state.updatePosition);
      window.removeEventListener('resize', state.updatePosition);
    }
    walletVideoStates.delete(video);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wallet-offer"] && !Shopify.designMode) return;
  try {
    
function initWalletOffers(scope=document){scope.querySelectorAll('[data-wallet-offer]').forEach(root=>{if(root.dataset.initialized)return;root.dataset.initialized='true';const slides=[...root.querySelectorAll('[data-wallet-slide]')];function show(id){slides.forEach(s=>s.hidden=s.dataset.walletSlide!==id);root.querySelectorAll('[data-wallet-thumb]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.walletThumb===id)));}root.querySelectorAll('[data-wallet-thumb]').forEach(b=>b.addEventListener('click',()=>show(b.dataset.walletThumb)));root.querySelectorAll('[data-wallet-swatch]').forEach(b=>b.addEventListener('click',()=>{root.querySelectorAll('[data-wallet-swatch]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));root.querySelector('[data-wallet-color-label]').textContent=b.dataset.walletSwatch;show(b.dataset.walletTarget);const select=root.querySelector('[data-wallet-variant]');if(select){const opt=[...select.options].find(o=>o.dataset.color===b.dataset.walletSwatch);if(opt){select.value=opt.value;select.dispatchEvent(new Event('change',{bubbles:true}));}}}));});}initWalletOffers();document.addEventListener('shopify:section:load',e=>initWalletOffers(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wallet-tracker-preview"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => {
    document.querySelectorAll('[data-wallet-tracker]').forEach(section => {
      if (section.dataset.trackerReady) return;
      section.dataset.trackerReady = 'true';
      const panels = Array.from(section.querySelectorAll('[data-tracker-panel]'));
      const buttons = Array.from(section.querySelectorAll('[data-tracker-target]'));
      buttons.forEach(button => {
        button.addEventListener('click', () => {
          const selected = panels.find(panel => panel.id === button.dataset.trackerTarget);
          if (!selected) return;
          panels.forEach(panel => { panel.hidden = panel !== selected; });
          buttons.forEach(control => control.setAttribute('aria-pressed', String(control === button)));
        });
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();
})();
